import { render, staticRenderFns } from "./GalleryTabs.vue?vue&type=template&id=0a91b586"
import script from "./GalleryTabs.vue?vue&type=script&lang=js"
export * from "./GalleryTabs.vue?vue&type=script&lang=js"
import style0 from "./GalleryTabs.vue?vue&type=style&index=0&id=0a91b586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports